import { NgModule } from "@angular/core";
import { CoreModule } from "../../../core/core.module";
import { SharedModule } from "../../../shared/shared.module";
import { ActivateUserComponent } from "./activate-user/activate-user.component";
import { CreateUserComponent } from "./create-user/create-user.component";
import { ManageUserComponent } from "./manage-user/manage-user.component";
import { UsersComponent } from "./users.component";

@NgModule({
  declarations: [CreateUserComponent, UsersComponent, ManageUserComponent, ActivateUserComponent],
  imports: [CoreModule, SharedModule],
  exports: [CreateUserComponent, UsersComponent, ManageUserComponent, ActivateUserComponent],
})
export class UserModule {}
